const menu = [
  {
    title: 'MENU & ORDERS',

    items: [
      {
        label: 'Dashboard',
        path: '/',
        icon: 'ph:house-simple',
      },

      {
        label: 'Catalog',
        path: '/catalog',
        icon: 'ph:tag',
      },

      {
        label: 'Orders',
        path: '/orders',
        icon: 'ph:receipt',
        badge: 5,
      },
    ],
  },

  {
    title: 'LOYALTY & PROMOTIONS',

    items: [
      {
        label: 'Vouchers',
        path: '/vouchers',
        icon: 'ph:ticket',
      },

      {
        label: 'Points Management',
        path: '/points-management',
        icon: 'ph:star',
      },
    ],
  },

  {
    title: 'Marketing',

    items: [
      {
        label: 'Campaign Links',
        path: '/marketing/links',
        icon: 'ph:cheers',
      },
    ],
  },

  {
    title: 'CUSTOMERS',

    items: [
      {
        label: 'Customers',
        path: '/customers',
        icon: 'ph:users',
      },
    ],
  },

  {
    title: 'ANALYTICS & SETTINGS',

    items: [
      {
        label: 'Sales Reporting',
        path: '/sales-reporting',
        icon: 'ph:chart-bar',
      },
      {
        label: 'Store Setup',
        path: '/store-setup',
        icon: 'ph:storefront',
      },
      {
        label: 'Payment Config',
        path: '/payment-config',
        icon: 'ph:money',
      },
      {
        label: 'Staff & Roles',
        path: '/staff',
        icon: 'ph:briefcase',
      },
    ],
  },
]

export default menu